import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get grnChargeStatus
export const getGrnChargeStatus = createAsyncThunk(
  "grnChargeStatus/getGrnChargeStatus",
  async (params, { rejectWithValue }) => {
    try {
      const { rowsPerPage, search, sortOrder, pageNo } = params;
      const { data } = await API.getGrnChargeStatus({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all grnChargeStatus
export const getAllGrnChargeStatus = createAsyncThunk(
  "grnChargeStatus/getAllGrnChargeStatus",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllGrnChargeStatus();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("grnChargeStatus/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("grnChargeStatus/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "grnChargeStatus/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageGrnChargeStatus({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get by id
export const getGrnChargeStatusById = createAsyncThunk(
  "grnChargeStatus/getGrnChargeStatusById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getGrnChargeStatusById(id);

      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create grnChargeStatus
export const createGrnChargeStatus = createAsyncThunk(
  "grnChargeStatus/createGrnChargeStatus",
  async (params, { rejectWithValue }) => {
    const { transactionType, isActive } = params;
    try {
      const body = JSON.stringify({ transactionType, isActive });
      const { data } = await API.createGrnChargeStatus(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateGrnChargeStatus = createAsyncThunk(
  "grnChargeStatus/updateGrnChargeStatus",
  async (param, { rejectWithValue }) => {
    const { id, values } = param;
    const { transactionType, isActive } = values;
    try {
      const body = JSON.stringify({ transactionType, isActive });
      const { data } = await API.updateGrnChargeStatus(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("grnChargeStatus/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
